import { CommonModule, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-button',
  imports: [CommonModule, TranslateModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.css'
})
export class ButtonComponent {
  @Input() type = 'button';
  @Input() label = 'Click';
  @Input() classesName = 'primary'; // you can expand colors
  @Input() disabled = false;
  @Input() iconClass: string = "";
  @Output() onBtnClick = new EventEmitter<any>();


  // This method is used to submit
  submit() {
    if (this.disabled) {
      return;
    }
    this.onBtnClick.emit();
  }
}
